import React from 'react';
import {Link} from 'react-router-dom';

const Footer = () => {
    return (
        <div className="footer">
            <div className="footer-left">
                <Link to="/" state={{scrollTo: 'contact-section'}}>Contact</Link>
            </div>

            <div className="footer-center">
                <p>Dockline Digital – Lucas Brand</p>
                <nav className="footer-locations">
                    <Link to="/webentwickler-muenchen">Webentwickler München</Link>
                    <Link to="/fotograf-muenchen">Fotograf München</Link>
                    <Link to="/it-administrator-muenchen">IT‑Administrator München</Link>
                </nav>
            </div>

            <div className="footer-right">
                <Link to="/imprint">Imprint/Privacy</Link>
                <Link to="/">Home</Link>
            </div>
        </div>
    );
};

export default Footer;